import { TaxiLandmarkApiTaxiLandmarkDeleteRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useTaxiLandmarkDeleteMutation = () =>
  useBaseMutation({
    mutationFn: (req: TaxiLandmarkApiTaxiLandmarkDeleteRequest, config) =>
      appApiClient.taxiLandmarkApi.taxiLandmarkDelete(req, config),
  });
